import React from "react";
import PlayerCard from "./PlayerCard";

const PositionGroup = ({ title, players, selectedPlayer, onSelectPlayer, isDarkMode, color }) => {
  if (!players || players.length === 0) return null;

  const colorStyles = {
    amber: isDarkMode ? "border-amber-500/30 text-amber-400" : "border-amber-300 text-amber-600",
    blue: isDarkMode ? "border-blue-500/30 text-blue-400" : "border-blue-300 text-blue-600",
    emerald: isDarkMode ? "border-emerald-500/30 text-emerald-400" : "border-emerald-300 text-emerald-600",
    rose: isDarkMode ? "border-rose-500/30 text-rose-400" : "border-rose-300 text-rose-600",
  }[color] || (isDarkMode ? "border-gray-600 text-gray-400" : "border-gray-300 text-gray-600");

  return (
    <div className="space-y-2">
      <div className={`flex items-center gap-2 px-1`}>
        <div className={`h-px flex-1 ${isDarkMode ? "bg-white/10" : "bg-gray-200"}`} />
        <span className={`text-[10px] font-semibold uppercase tracking-wider ${colorStyles.split(' ')[1]}`}>
          {title} ({players.length})
        </span>
        <div className={`h-px flex-1 ${isDarkMode ? "bg-white/10" : "bg-gray-200"}`} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {players.map((player) => (
          <PlayerCard
            key={player.id}
            player={player}
            onSelect={onSelectPlayer}
            isSelected={selectedPlayer?.id === player.id}
            isDarkMode={isDarkMode}
          />
        ))}
      </div>
    </div>
  );
};

export default PositionGroup;
